export default __webpack_public_path__ + "static/1563-106a006060d73065c0a87d1f6200996e.gif";